import { StyledButtonIcon } from "./Button-styled";

const IconButton = ({ children, selected, size = "md", width, ...props }) => {
  return (
    <StyledButtonIcon selected={selected} size={size} width={width} {...props}>
      {children}
    </StyledButtonIcon>
  );
};

export default IconButton;
